<template>
  <div class="right-container">
    <div
      id="preview-container"
      class="preview-container"
    >
      <div class="iframe-container">
        <canvas id="my-canvas" />
        <div
          id="map-mask"
          class="map-mask"
        />
        <iframe
          id="editor-js-iframe"
          title="iframe"
          scrolling="no"
        />
      </div>
    </div>
    <div class="code-container">
      <div
        id="editor-col-resize"
        class="editor-col-resize"
      />
      <div
        id="editor-code-arrow"
        :class="[showCode ? 'go-back' : '', 'show']"
        @click="toggleCode"
      >
        <span title="显示并修改代码" />
        <p title="隐藏代码" />
      </div>
      <div id="editor-code-core">
        <div class="editor-code-related">
          <div class="editor-code-head">
            <span
              id="editor-code-run"
              class="editor-code-run"
              @click="runCode"
            >运行</span>
            <span
              id="editor-code-copy"
              class="editor-code-copy"
            >复制</span>
            <span
              id="editor-code-restore"
              class="editor-code-restore"
              @click="resetCode"
            >还原</span>
            源代码编辑器
          </div>
          <div class="editor-code-body">
            <textarea
              id="editor-code-textarea"
              cols="30"
              rows="10"
            />
          </div>
          <div id="editor-console-wrapper">
            <div class="editor-code-head">
              <span
                id="editor-code-clear"
                class="editor-code-clear"
                @click="clearCode"
              >清空</span>
              控制台
            </div>
            <div id="editor-js-console">
              <div id="editor-output" />
              <div
                id="editor-code-console"
                class="editor-console-content"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        v-show="showMessage"
        class="editor-message"
      >
        <div class="message-img" />
        <p>已复制</p>
      </div>
    </div>
  </div>
</template>
<script>
import Clipboard from 'clipboard';
import mockCode from './mock-code';
const INIT_WIDTH = 546;

export default {
  name: 'CodeEditor',
  props: {
    code: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showCode: true,
      showMessage: false
    };
  },
  watch: {
    code() {
      this.setCode(this.code);
      this.initCode(this.code);
    }
  },
  mounted() {
    this.CodeMirror = require('codemirror/lib/codemirror');
    require('codemirror/lib/codemirror.css');
    require('codemirror/mode/htmlmixed/htmlmixed');
    this.initCode(this.code);
    this.initEditor();
    this.initStyle();
    this.initConsole();
    this.initCopy();
    this.runCode();
    this.handleResizeCode();
    this.handleResizeConsole();
    window.setIFrameResult = (type, ...text) => {
      $('#editor-output').append(this.createConsoleResult(type, ...text));
      this.consoleEditor.setValue('');
    };
  },
  destroyed() {
    delete window.setIFrameResult;
  },
  methods: {
    initCode(code = '') {
      this.codeTextArea = document.getElementById('editor-code-textarea');
      $(this.codeTextArea).val(code);
      this.codeStorage = code;
    },
    initEditor() {
      this.codeMirrorEditor = this.CodeMirror.fromTextArea(this.codeTextArea, {
        lineNumbers: true, // 显示行号
        lineWrapping: true,
        styleActiveLine: true,
        matchBrackets: true,
        mode: 'htmlmixed',
        viewportMargin: Infinity
      });
    },
    initStyle() {
      const gl = document.getElementById('my-canvas').getContext('experimental-webgl');
      if (!gl) return;
      const h = parseInt(gl.getParameter(gl.MAX_TEXTURE_SIZE) / window.devicePixelRatio, 0);
      document.getElementsByClassName('left-container')[0].style.maxHeight = `${h}px`;
      document.getElementsByClassName('iframe-container')[0].style.maxHeight = `${h}px`;
      document.getElementsByClassName('right-container')[0].style.maxHeight = `${h}px`;
    },
    initConsole() {
      this.consoleEditor = this.CodeMirror(document.getElementById('editor-code-console'), {
        value: 'console.log(\'可以在这里进行实时调试，输入代码后按Enter执行\')',
        mode: 'javascript',
      });
      this.consoleEditor.setOption('extraKeys', {
        Enter: () => {
          const sandbox = document.getElementById('editor-js-iframe');
          const code = this.consoleEditor.getValue();
          const iframeWindow = sandbox.contentWindow || sandbox.contentDocument;
          if (code.length > 0) {
            window.setIFrameResult('code', code);
            iframeWindow.Kconsole.exec(code);
          }
        }
      });
    },
    initCopy() {
      /** 复制功能 **/
      const sCopy = () => {
        let iframeContent = $('#editor-code-textarea').val();
        if (this.codeMirrorEditor) {
          iframeContent = this.codeMirrorEditor.getValue();
        }
        return iframeContent;
      };

      const self = this;

      // 复制功能绑定
      this.clipboard = new Clipboard('#editor-code-copy', {
        text: function () {
          return sCopy();
        }
      });
      this.clipboard
        .on('success', function (e) {
          self.showMessage = true;
          setTimeout(() => {
            self.showMessage = false;
          }, 2000);
          e.clearSelection();
        })
        .on('error', function (e) {
          console.error('Action:', e.action);
          console.error('Trigger:', e.trigger);
          alert('复制失败，请重试 :(');
        });
    },
    runCode() {
      let iframeContent = $(this.codeTextArea).val();
      if (this.codeMirrorEditor) {
        iframeContent = this.codeMirrorEditor.getValue();
      }
      const iFrameOld = document.getElementById('editor-js-iframe');
      const [iFrameContent] = document.getElementsByClassName('iframe-container');
      iFrameContent.removeChild(iFrameOld);
      const iFrameNew = document.createElement('iframe');
      iFrameNew.setAttribute('id', 'editor-js-iframe');
      iFrameNew.setAttribute('title', 'iframe');
      iFrameNew.setAttribute('scrolling', 'no');
      iFrameContent.appendChild(iFrameNew);
      const iFrame = document.getElementById('editor-js-iframe');
      if (!iFrame) {
        return;
      }
      const iFrameWindow = iFrame.contentWindow || iFrame.contentDocument;
      let doc;
      if (iFrameWindow.document) {
        doc = iFrameWindow.document;
      }
      if (!doc) {
        return;
      }
      const nr = iframeContent.indexOf('<body');
      const iframeHead = iframeContent.slice(0, nr);
      const iframeFooter = iframeContent.slice(nr, iframeContent.length);
      doc.open();
      doc.write(iframeHead);
      doc.write(mockCode);
      doc.write(iframeFooter);
      doc.close();
    },
    handleResizeCode() {
      const dragColObj = {};
      const mapMask = $('#map-mask');
      const oCodeCore = $('#editor-code-core');
      const jsDemoBody = $('.preview-container');
      const self = this;
      $('body').on('mousedown', '#editor-col-resize', function (e) {
        e.preventDefault();
        dragColObj.down = true;
        dragColObj.x = e.clientX;
        dragColObj.width = $(window).width();
        mapMask.addClass('show');
      })
        .on('mousemove', function (e) {
          const oThis = $(this);
          const bodyWidth = oThis.width();

          if (!dragColObj.down) {
            return;
          }
          const x = e.clientX;
          const result = dragColObj.width - x;

          if (result > bodyWidth * 0.5 || result < 300) {
            return;
          }

          self.codeWrapWidth = result;
          oCodeCore.width(result);
        })
        .on('mouseup', function () {
          const oCodeCoreWidth = oCodeCore.width();
          jsDemoBody.css({ marginRight: oCodeCoreWidth });
          mapMask.removeClass('show');
          self.codeMirrorEditor.refresh();
          delete dragColObj.down;
        });
    },
    handleResizeConsole() {
      const dragObj = {};
      const consoleWrapper = $('#editor-console-wrapper');
      const body = $('#editor-code-core').find('.editor-code-body');
      $('body').on('mousedown', '#editor-console-wrapper .editor-code-head', function (e) {
        e.preventDefault();
        dragObj.down = true;
        dragObj.top = consoleWrapper[0].offsetTop;
        dragObj.y = e.clientY;
      })
        .on('mousemove', function (e) {
          if (!dragObj.down) {
            return;
          }
          const y = e.clientY;
          const top = dragObj.top - (dragObj.y - y);
          const total = $('.editor-code-related').height();
          const consolePercent = Math.round((total - top) * 1000000 / total) / 10000;
          if (consolePercent > 80 || consolePercent < 20) {
            return;
          }
          consoleWrapper.css('height', `${consolePercent}%`);
          body.css('bottom', `${consolePercent}%`);
        })
        .on('mouseup', function () {
          delete dragObj.down;
        });
    },
    clearCode(e) {
      e.preventDefault();
      $('#editor-output').empty();
    },
    createConsoleResult(type, ...text) {
      const div = document.createElement('div');
      const str = this.fixCode(...text);
      div.appendChild(document.createTextNode(str));
      $(div).addClass(`output-${type}`);
      return div;
    },
    fixCode(...text) {
      let arr = [...text];
      arr = arr.map(item => {
        return this.findSpecial(item);
      });
      return arr.join(' ');
    },
    findSpecial(item) {
      if (item === undefined) {
        return 'undefined';
      }
      if (item === null) {
        return 'null';
      }
      if (Array.isArray(item)) {
        const temp =  item.map(val => {
          return this.findSpecial(val);
        });
        return `[${temp}]`;
      }
      return String(item);
    },
    toggleCode() {
      const { showCode } = this;
      const codeCodeDom = document.getElementById('editor-code-core');
      const previewContainerDom = document.getElementById('preview-container');
      if (showCode) {
        codeCodeDom.style.width = 0;
        previewContainerDom.style.marginRight = 0;
      } else {
        codeCodeDom.style.width = `${this.codeWrapWidth || INIT_WIDTH}px`;
        previewContainerDom.style.marginRight = `${this.codeWrapWidth || INIT_WIDTH}px`;
      }
      this.showCode = !showCode;
    },
    getCode() {
      return this.codeMirrorEditor.getValue();
    },
    resetCode() {
      this.codeMirrorEditor.setValue(this.codeStorage);
      this.runCode();
    },
    setCode(code = '') {
      this.codeMirrorEditor.setValue(code);
      this.runCode();
    }
  }
};
</script>
<style lang="scss">
@import "./index.scss";
</style>
